import { createCustomSlice } from './customSlice';

export const inProgressSlice = createCustomSlice('progress');
